module.exports = __webpack_public_path__ + "img/banner.07149c3c.png";